import axios from 'axios';
import api from '../../../config/axios-interceptor';

const buildParams = (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, value);
        }
    });
    return params;
};

/** One page of the audit trail. Sort uses the ENTITY property name, not the column name. */
export const fetchAuditLog = async (page = 0, pageSize = 20, filters = {}) => {
    try {
        const params = buildParams(filters);
        params.append('page', page.toString());
        params.append('size', pageSize.toString());
        params.append('sort', 'occurredAt,desc');
        return await api.get(`/api/v1/audit-log/find-all?${params.toString()}`);
    } catch (error) {
        console.error('❌ Error fetching audit log:', error);
        throw error;
    }
};

/** The action vocabulary, read from the server so the dropdown cannot drift from what is recorded. */
export const fetchAuditActions = async () => {
    try {
        return await api.get('/api/v1/audit-log/actions');
    } catch (error) {
        console.error('❌ Error fetching audit actions:', error);
        throw error;
    }
};

/**
 * Download the current filter's rows as CSV.
 *
 * Deliberately NOT using the shared `api` instance. Its response interceptor returns `response.data`
 * and throws the rest of the response away, so a download made through it loses Content-Disposition
 * — and its request interceptor forces `Content-Type: application/json`, which is wrong for a file
 * download. So this is a raw axios call that re-adds the bearer token itself.
 */
export const exportAuditLog = async (filters = {}) => {
    const params = buildParams(filters);
    const token = localStorage.getItem('access-token');
    const base = process.env.REACT_APP_API_BASE_URL || '';
    const response = await axios.get(`${base}/api/v1/audit-log/export?${params.toString()}`, {
        responseType: 'blob',
        headers: token ? {Authorization: `Bearer ${token}`} : {},
    });

    // Prefer the filename the server chose; fall back to one built here so the download is never
    // called "download".
    const disposition = response.headers?.['content-disposition'] || '';
    const match = /filename="?([^"]+)"?/.exec(disposition);
    const filename = match ? match[1] : `audit-log-${new Date().toISOString().replace(/:/g, '-')}.csv`;

    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'text/csv;charset=utf-8'}));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return filename;
};
